import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { AgeSelector } from './components/AgeSelector';
import { Dashboard } from './components/Dashboard';
import { AlphabetLesson } from './components/AlphabetLesson';
import { GridLesson } from './components/GridLesson';
import { MatchingGame } from './components/MatchingGame';
import { MemoryGame } from './components/MemoryGame';
import { Quiz } from './components/Quiz';
import { numbers, colors, animals, greetings } from './data/arabic';
import './index.css';

type View = 'age' | 'dashboard' | 'alphabet' | 'numbers' | 'colors' | 'animals' | 'greetings' | 'matching' | 'memory' | 'quiz';

function App() {
  const [age, setAge] = useState<'little' | 'big' | null>(null);
  const [view, setView] = useState<View>('age');

  const handleAge = (a: 'little' | 'big') => { setAge(a); setView('dashboard'); };
  const handleSection = (s: string) => setView(s as View);
  const goBack = () => setView('dashboard');

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
      {view === 'age' && <AgeSelector onSelect={handleAge} />}
      {view === 'dashboard' && age && <Dashboard age={age} onSelect={handleSection} onBack={() => setView('age')} />}
      {view === 'alphabet' && age && <AlphabetLesson onBack={goBack} age={age} />}
      {view === 'numbers' && <GridLesson title="Numbers" arabicTitle="الأرقام" items={numbers} onBack={goBack} color="#4ECDC4" />}
      {view === 'colors' && <GridLesson title="Colors" arabicTitle="الألوان" items={colors} onBack={goBack} color="#FF9F43" />}
      {view === 'animals' && <GridLesson title="Animals" arabicTitle="الحيوانات" items={animals} onBack={goBack} color="#95E1D3" />}
      {view === 'greetings' && <GridLesson title="Greetings" arabicTitle="التحيات" items={greetings} onBack={goBack} color="#A8DADC" />}
      {view === 'matching' && age && <MatchingGame onBack={goBack} age={age} />}
      {view === 'memory' && age && <MemoryGame onBack={goBack} age={age} />}
      {view === 'quiz' && age && <Quiz onBack={goBack} age={age} />}
    </motion.div>
  );
}

export default App;
